<div class="feed-level-layout-and-format">
  @if (visibleTabs.length) {
    <sui-tabs
      [tabs]="tabItems"
      [value]="activeTabValue"
      (valueChange)="onTabChange($event)"
    ></sui-tabs>
  }

  @if (visibleTabs.length) {
    <div>
      @for (tab of visibleTabs; track tab) {
        <div>
          @if (activeFormatTab === tab.key && getFormGroupForFormat(tab.key)) {
            <div>
              <app-output-settings-format-editor
                [outputSettings]="outputSettings"
                [outputFormatId]="tab.key"
                [formGroup]="getFormGroupForFormat(tab.key)"
                [searchString$]="searchString$"
              ></app-output-settings-format-editor>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- empty state -> if no Tabs -->
  @if (!visibleTabs.length) {
    <sui-empty-state
      [title]="
        'output-settings.message.no-format-settings-available' | translate
      "
    ></sui-empty-state>
  }
</div>
